import React from "react";

export default function TempleRakshak() {
  return (
    <>
      <style>{`

      *{
        margin:0;
        padding:0;
        box-sizing:border-box;
      }

      body{
        font-family:"Poppins",sans-serif;
        background:#f3ead7;
      }

      .temple-page{
        width:100%;
        min-height:100vh;
        background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
        color:#222;
        padding:80px 0;
      }

      .container{
        width:92%;
        max-width:1200px;
        margin:auto;
      }

      /* MAIN TITLE */

      .main-title{
        text-align:center;
        margin-bottom:70px;
      }

      .main-title h1{
        font-size:48px;
        font-weight:900;
        color:#000;
        margin-bottom:20px;
        line-height:1.1;
      }

      .main-title h2{
        font-size:36px;
        font-weight:700;
        color:#8b5a00;
        line-height:1.3;
        margin-bottom:35px;
      }

      .main-title p{
        max-width:1000px;
        margin:auto;
        font-size:20px;
        line-height:1.5;
      }

      /* SECTION */

      .section{
        margin-bottom:65px;
      }

      .section-title{
        font-size:40px;
        font-weight:800;
        color:#8b5a00;
        margin-bottom:25px;
        line-height:1;
      }
      .section-titles{
        font-size:30px;
        font-weight:600;
        color:#8b5a00;
        margin-bottom:25px;
        line-height:1;
      }

      .section p{
        font-size:20px;
        line-height:1.5;
        margin-bottom:25px;
      }

      .section ul{
        padding-left:25px;
        margin-top:20px;
      }

      .section li{
        font-size:20px;
        line-height:1;
        margin-bottom:14px;
      }

      .price{
        font-size:38px;
        font-weight:700;
        color:#c58b2a;
        margin:20px 0 25px;
      }
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
.intro-image{
  display:flex;
  justify-content:center;
  margin:40px 0 15px;
}

.intro-image img{
  width:100%;
  max-width:900px;
  border:8px solid #fff;
  border-radius:20px;
  box-shadow:
    0 12px 35px rgba(0,0,0,0.18),
    0 0 0 4px #e80707ff;
  transition:0.35s ease;
}

.intro-image img:hover{
  transform:scale(1.02);
  box-shadow:
    0 18px 45px rgba(0,0,0,0.25),
    0 0 0 4px #4a160eff;
}
.membership-box{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:35px;
  margin:35px 0;
  padding:35px;
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
  border-radius:22px;
  border:3px solid #d4af37;
  box-shadow:0 15px 35px rgba(0,0,0,.12);
}

.membership-btn{
  background:linear-gradient(135deg,#c58b2a,#f4c542);
  color:#fff;
  font-size:34px;
  font-weight:800;
  border:none;
  border-radius:18px;
  padding:22px 42px;
  cursor:pointer;
  transition:.35s;
  box-shadow:0 10px 25px rgba(197,139,42,.35);
  text-transform:uppercase;
}

.membership-btn:hover{
  transform:translateY(-4px) scale(1.04);
  box-shadow:0 18px 35px rgba(197,139,42,.45);
}

.payment-info{
  flex:1;
}

.payment-info h3{
  color:#8b5a00;
  font-size:24px;
  margin-bottom:18px;
}

.payment-info p{
  margin:10px 0 !important;
  font-size:20px !important;
  line-height:1.4 !important;
}

.payment-info strong{
  color:#1a2a5a;
}
.payment-row{
  display:flex;
  gap:25px;
  align-items:flex-start;
}

.payment-card{
  flex:1;
  font-size:20px;
  line-height:1.4;
}

.payment-card strong{
  color:#1a2a5a;
  font-size:21px;
}
      /* MOBILE */

@media (max-width: 768px) {
  .intro-image{
    margin:22px 0 10px;
  }

  .intro-image img{
    border:5px solid #fff;
    border-radius:14px;
    box-shadow:
      0 8px 20px rgba(0,0,0,0.18),
      0 0 0 3px #d4af37;
  }
  .temple-page{
    padding:40px 0;
  }

  .container{
    width:95%;
  }

  .main-title{
    margin-bottom:30px;
  }

  .main-title h1{
    font-size:24px;
    line-height:1.1;
    margin-bottom:12px;
  }

  .main-title h2{
    font-size:16px;
    line-height:1.2;
    margin-bottom:16px;
  }

  .main-title p{
    font-size:13px !important;
    line-height:1.4 !important;
  }

  .section{
    margin-bottom:32px;
  }

  .section-title{
    font-size:18px;
    line-height:1.2;
    margin-bottom:12px;
  }

  .section-titles{
    font-size:17px;
    line-height:1.2;
    margin-bottom:10px;
  }

  .section p{
    font-size:13px !important;
    line-height:1.4;
    margin-bottom:12px;
  }
  

  .section li{
    font-size:14px;
    line-height:1;
    margin-bottom:8px;
  }

  .section ul{
    padding-left:18px;
  }

  h4{
    font-size:14px;
    margin-bottom:8px;
  }

  .price{
    font-size:28px;
    margin:12px 0;
  }

  .section-divider{
    margin:16px auto 20px;
    gap:10px;
  }

  .section-divider span{
    font-size:16px;
  }

  .section-divider::before,
  .section-divider::after{
    height:2px;
  }
  .membership-box{
    flex-direction:column;
    text-align:center;
    padding:22px;
    gap:20px;
  }

  .membership-btn{
    width:100%;
    font-size:24px;
    padding:18px;
  }

  .payment-info h3{
    font-size:18px;
  }

  .payment-info p{
    font-size:15px !important;
  }
  .payment-row{
    flex-direction:column;
    gap:18px;
  }

  .payment-card{
    text-align:center;
    font-size:15px;
  }

  .payment-card strong{
    font-size:16px;
  }
}

      `}</style>

      <div className="temple-page">

        <div className="container">

          <div className="main-title">

            <h1>A4H CHARITABLE & COMMUNITY SERVICES</h1>
            <div className="section-divider">
  <span>✦ ✦ ✦</span>
</div>
            <h2>
              Serving Humanity Through Seva
            </h2>

            <p>
              A4H Charitable & Community Services is a flagship initiative of Americans4Hindus – 501(c)(3) Nonprofit Organization, dedicated to advancing charitable, educational, wellness, and humanitarian programs that strengthen individuals, families, and communities across the United States.
            </p>

            <p>
              Guided by the Hindu principle of Seva (selfless service), Americans4Hindus Nonprofit Organization seeks to create meaningful social impact through volunteer-driven initiatives, health and wellness education, community outreach, and support programs for underserved populations.
            </p>

            <p>
              Our mission is to promote compassion, community responsibility, wellness, and service while building stronger and more resilient communities.
            </p>

          </div>

          {/* SECTION 1 */}

          <div className="section">

            <h2 className="section-title">
              1. FREE HEALTH & WELLNESS FAIR
            </h2>

            <h2 className="section-titles">
              Promoting Preventive Health and Community Wellness
            </h2>

            <p>
              The Americans4Hindus Nonprofit Organization Free Health & Wellness Fair is designed to increase awareness about preventive healthcare, healthy lifestyles, and community wellness resources.
            </p>

            <p>
              Through partnerships with healthcare professionals, community organizations, and volunteers, these events provide educational opportunities that empower individuals and families to make informed health decisions.
            </p>

            <h4>Key Focus Areas</h4>

            <ul>
              <li>Health education and awareness</li>
              <li>Preventive wellness resources</li>
              <li>Healthy lifestyle guidance</li>
              <li>Community health information</li>
              <li>Wellness workshops and seminars</li>
            </ul>

            <h4>Our Goal</h4>

            <p>
              To improve community well-being by increasing access to health education and encouraging preventive wellness practices.
            </p>

          </div>

          {/* SECTION 2 */}

          <div className="section">

            <h2 className="section-title">
              2. TOY DRIVE
            </h2>

            <h2 className="section-titles">
              Bringing Joy to Children and Families
            </h2>

            <p>
              The Americans4Hindus Nonprofit Organization Toy Drive is a charitable initiative that collects and distributes toys, educational materials, and gifts to children and families facing economic hardship.
            </p>

            <p>
              This program brings together donors, volunteers, and community partners to create meaningful experiences for children while promoting a culture of generosity and compassion.
            </p>

            <h4>Program Objectives</h4>

            <ul>
              <li>Support underserved children and families</li>
              <li>Encourage charitable giving</li>
              <li>Promote volunteer engagement</li>
              <li>Foster community compassion</li>
            </ul>

            <h4>Our Goal</h4>

            <p>
              To ensure that children from all backgrounds experience joy, hope, and encouragement during holidays and community celebrations.
            </p>

          </div>

          {/* SECTION 3 */}

          <div className="section">

            <h2 className="section-title">
              3. BLANKET DRIVE
            </h2>

            <h2 className="section-titles">
              Providing Warmth, Comfort, and Care
            </h2>

            <p>
              The Americans4Hindus Nonprofit Organization Blanket Drive supports vulnerable individuals and families by collecting and distributing blankets and essential comfort items during colder seasons and emergency situations.
            </p>

            <p>
              This initiative reflects our commitment to serving those in need through practical acts of compassion and community support.
            </p>

            <h4>Program Objectives</h4>

            <ul>
              <li>Support individuals experiencing hardship</li>
              <li>Assist underserved communities</li>
              <li>Mobilize community volunteers</li>
              <li>Promote humanitarian service</li>
            </ul>

            <h4>Our Goal</h4>

            <p>
              To provide warmth, comfort, and dignity to individuals and families facing challenging circumstances.
            </p>

          </div>

          {/* SECTION 4 */}

          <div className="section">

            <h2 className="section-title">
              4. FOOD FOR THE POOR & HOMELESS
            </h2>

            <h2 className="section-titles">
              Addressing Hunger Through Community Service
            </h2>

            <p>
              The Americans4Hindus Nonprofit Organization Food for the Poor & Homeless Program focuses on hunger-relief efforts through food drives, meal distribution initiatives, volunteer service projects, and partnerships with charitable organizations.
            </p>

            <p>
              Inspired by the spirit of Seva, this initiative seeks to support individuals and families experiencing food insecurity while encouraging community participation in humanitarian service.
            </p>

            <h4>Program Activities</h4>

            <ul>
              <li>Food collection drives</li>
              <li>Meal distribution programs</li>
              <li>Community service projects</li>
              <li>Hunger awareness initiatives</li>
              <li>Volunteer engagement opportunities</li>
            </ul>

            <h4>Our Goal</h4>

            <p>
              To help reduce hunger, support vulnerable populations, and strengthen communities through collective service.
            </p>

          </div>

          {/* SECTION 5 */}

          <div className="section">

            <h2 className="section-title">
              5. YOG SERVICES
            </h2>

            <h2 className="section-titles">
              Yoga • Meditation • Mindfulness • Ayurveda • Integrated Wellness Education
            </h2>

            <h2 className="section-titles">
              Promoting Holistic Well-Being
            </h2>

            <p>
              The Americans4Hindus Nonprofit Organization Yog Services Program promotes physical, mental, emotional, and spiritual well-being through educational programs inspired by the holistic traditions of Yoga, Meditation, Mindfulness, Ayurveda, and Integrated Wellness practices.
            </p>

            <p>
              These programs are designed to help individuals develop healthier lifestyles, manage stress, improve overall wellness, and cultivate inner balance.
            </p>

            <h4>Program Components</h4>

            <p><strong>Yoga Education</strong></p>

            <p>
              Programs that promote flexibility, fitness, physical wellness, and healthy living.
            </p>

            <p><strong>Meditation & Mindfulness</strong></p>

            <p>
              Educational workshops that encourage focus, emotional well-being, stress management, and self-awareness.
            </p>

            <p><strong>Ayurveda Awareness</strong></p>

            <p>
              Educational sessions introducing traditional wellness concepts, healthy habits, nutrition awareness, and balanced living.
            </p>

            <p><strong>Integrated Wellness Education</strong></p>

            <p>
              Programs that explore complementary wellness approaches alongside modern health awareness practices.
            </p>

            <h4><strong>Our Goal</strong></h4>

            <p>
              To empower individuals with knowledge and wellness practices that support lifelong health and personal well-being.
            </p>

            <h4><strong>Disclaimer</strong></h4>

            <p>
              Educational information provided through this program is intended for informational and wellness purposes only and should not be considered medical advice or a substitute for consultation with qualified healthcare professionals.
            </p>

          </div>

          {/* SECTION 6 */}

          <div className="section">

            <h2 className="section-title">
              6. MENTAL HEALTH & EMOTIONAL WELLNESS
            </h2>

            <h2 className="section-titles">
              Building Stronger Minds and Healthier Communities
            </h2>

            <p>
              The Americans4Hindus Nonprofit Organization Mental Health & Emotional Wellness Initiative promotes awareness, education, and community support related to mental and emotional well-being.
            </p>

            <p>
              Recognizing that mental health is an essential part of overall wellness, this initiative seeks to reduce stigma, encourage open conversations, and connect individuals with educational resources and support networks.
            </p>

            <h4>Focus Areas</h4>

            <ul>
              <li>Mental health awareness</li>
              <li>Stress management education</li>
              <li>Emotional wellness resources</li>
              <li>Youth and family wellness programs</li>
              <li>Community support initiatives</li>
            </ul>

            <h4>Our Goal</h4>

            <p>
              To foster a culture of understanding, compassion, and support where individuals feel empowered to prioritize their emotional and mental well-being.
            </p>

          </div>

          {/* WHY IT MATTERS */}

          <div className="section">

            <h2 className="section-title">
              WHY A4H CHARITABLE & COMMUNITY SERVICES MATTERS
            </h2>

            <p>
              Americans4Hindus – 501(c)(3) Nonprofit Organization believes that service is one of the highest expressions of leadership and community responsibility.
            </p>

            <p>
              Through health, wellness, humanitarian, and charitable initiatives, A4H Charitable & Community Services seeks to improve lives, strengthen communities, and inspire individuals to contribute positively to society.
            </p>

            <p>
              By bringing together volunteers, professionals, community leaders, donors, and supporters, we are creating opportunities to serve, uplift, and empower communities throughout America.
            </p>

          </div>

        </div>

      </div>
    </>
  );
}